import { useEffect, useState } from "react"
import ControleAcessoService from "../../../services/ControleAcessoService"
import { Autocomplete } from "@material-ui/lab"
import { CircularProgress, TextField } from "@material-ui/core"
import enumPerfisAcesso from '../../../enums/enumPerfisAcesso'
import { useAuth } from 'react-oidc-context'

export default function PesquisaPerfisManutencaoAcessos({ value, setValue, error, disabled, idOrgao }) {
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [pesquisaPerfil, setPesquisaPerfil] = useState(false)
    const auth = useAuth();

    const loading = open && pesquisaPerfil

    const CarregaPerfis = () => {
        let idOrgaoPesquisa = 0
        if (idOrgao) {
            idOrgaoPesquisa = idOrgao
        }

        setPesquisaPerfil(true);
        ControleAcessoService.ConsultaPerfisManutencaoAcessos(idOrgaoPesquisa)
            .then(response => {                
                if (auth !== undefined &&
                    auth.user !== undefined &&
                    auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') === undefined &&
                    auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') === undefined &&
                    auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined) {
                    // Não é possível conceder acesso ao perfil de "1 - Gestor de Acessos do Jurisdicionado", pois
                    // somente o Gestor de Órgão Jurisdicionado pode conceder tal acesso.
                    response.data = response.data.filter(perfil => perfil.id !== enumPerfisAcesso.OperadorGestorAcessosOrgaoJurisdicionado)
                }

                // Não é possível conceder acesso ao perfil de "99 - Gestor do Órgão Jurisdicionado" através desta tela, pois
                // a liberação deste perfil é feita exclusivamente através da funcionalidade "Controle de Acesso TCE-GO".
                response.data = response.data.filter(perfil => perfil.id !== enumPerfisAcesso.OperadorGestorOrgaoJurisdicionado)

                setOptions(response.data)
                setPesquisaPerfil(false);
            })
            .catch(() => {
                setOptions([])
                setPesquisaPerfil(false);
            })
    }

    useEffect(() => {
        if (!loading) {
            return undefined
        }
    }, [loading])

    useEffect(() => {
        if (!open) {
            setOptions([])
        }
        else {
            CarregaPerfis()
        }
    }, [open])

    return (
        <Autocomplete
            multiple
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={value}
            onChange={(event, newValue) => {
                const itensSelecionados = [];

                newValue.reduce((novoItem, itemAtual) => {
                    if (novoItem.indexOf(itemAtual.id) === -1) {
                        novoItem.push(itemAtual.id);
                        itensSelecionados.push(itemAtual);
                    }

                    return novoItem;
                }, []);

                setOptions([]);
                setValue(itensSelecionados);
            }}
            getOptionLabel={(option) => option.nome}
            options={options}
            loading={loading}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Perfil"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress style={{ color: 'var(--primary)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    error={error ? error.errorState : false}
                    helperText={error ? error.errorHelperText : ""}
                    placeholder="Selecione outro perfil..."
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                />
            )}
            disabled={disabled}
        />
    )
}